import { call, put, takeEvery } from 'redux-saga/effects'

import { ProductService } from '@/services'
import { orderService } from '@/services/order'
import { productComparisonActions } from '@/store/slices/productComparisonSlice'
import { STATUS_CODE } from '@/libs/constants'
import { filterEmptyElementInArray } from '@/libs/utils/array'

function* getProductDetails({ payload }) {
  const { materialNumber } = payload
  try {
    const { data } = yield ProductService.getComparisonDetails(materialNumber)

    const reducedProductDetails = data.reduce((result, product) => {
      const { materialNumber: productId, equipments, technicalData } = product

      const filteredEquipments = filterEmptyElementInArray(equipments)
      const filteredTechnicalData = filterEmptyElementInArray(technicalData)

      result[productId] = {
        ...product,
        equipments: filteredEquipments,
        technicalData: filteredTechnicalData,
      }
      return result
    }, {})

    const dataById = materialNumber.reduce((result, productId) => {
      const productData = reducedProductDetails[productId]
      result[productId] = productData
      return result
    }, {})

    yield put(
      productComparisonActions.getProductComparisonDataSuccess(dataById),
    )
  } catch (error) {
    console.error('Error fetching product comparison data:', error)
    yield put(
      productComparisonActions.getProductComparisonDataFailure({
        materialNumber,
      }),
    )
  }
}

function* getProductPrice(action) {
  const { materialNumber } = action.payload
  try {
    const response = yield call(orderService.getPriceBoxData, materialNumber)
    if (response.status === STATUS_CODE.SUCCESS) {
      yield put(
        productComparisonActions.getProductComparisonPriceSuccess(response.data),
      )
    }
  } catch (error) {
    console.error('Error fetching product comparison price:', error)
    yield put(
      productComparisonActions.getProductComparisonPriceFailure({
        materialNumber,
      }),
    )
  }
}

function* watchProductComparison() {
  yield takeEvery(
    productComparisonActions.getProductComparisonData.type,
    getProductDetails,
  )
  yield takeEvery(
    productComparisonActions.getProductComparisonPrice.type,
    getProductPrice,
  )
}

export default watchProductComparison
